import React, { createContext } from "react";

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Landing page solo necesita un contexto vacío
  const value = {};

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};
